import React, { useState, useRef } from 'react';
import { profileAPI } from './SellerApi';

export const SellerPolicies = () => {
  const [agreed, setAgreed] = useState(false);
  const [signed, setSigned] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);

  const seller = JSON.parse(localStorage.getItem('seller_user') || '{}');

  const startDraw = (e) => {
    setDrawing(true);
    const c = canvasRef.current; 
    const ctx = c.getContext('2d');
    const r = c.getBoundingClientRect();
    ctx.beginPath(); 
    ctx.moveTo(e.clientX - r.left, e.clientY - r.top);
    setSigned(true);
  };

  const draw = (e) => {
    if (!drawing) return;
    const c = canvasRef.current; 
    const ctx = c.getContext('2d');
    const r = c.getBoundingClientRect();
    ctx.lineWidth = 2; 
    ctx.strokeStyle = '#10b981'; 
    ctx.lineCap = 'round';
    ctx.lineTo(e.clientX - r.left, e.clientY - r.top); 
    ctx.stroke();
  };

  const stopDraw = () => setDrawing(false);

  const handleCommit = async () => {
    if (!agreed || !signed) return;
    setSubmitting(true);
    try {
      await profileAPI.agreePolicies();
      setDone(true);
    } catch (err) {
      alert("Error logging dynamic verification framework.");
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="sp-card" style={{ textAlign: 'center', padding: '3rem' }}>
        <h2 style={{ color: 'var(--em-400)' }}>✓ Onboarding Protocol Signed</h2>
        <p style={{ color: 'var(--t2)', marginTop: '0.5rem' }}>Your digital verification profile has been logged on the distributed ledger.</p>
      </div>
    );
  }

  return (
    <div className="sp-card">
      <div className="sp-card-title">Corporate Master Marketplace Agreement</div>
      <div className="sp-policy-body" style={{ height: 200, overflowY: 'auto', background: 'var(--s0)', padding: '1rem', borderRadius: 'var(--r-md)', fontSize: 13, color: 'var(--t2)', border: '1px solid var(--border)', marginBottom: '1.5rem' }}>
        <h3>1. Platform Fee Structure & Operational Margins</h3>
        <p>By executing this agreement, the partner merchant consents to a standardized marketplace listing fee structure on finished product retail invoices processed via ATR Mart networks...</p>
        <h3 style={{ marginTop: '1rem' }}>2. Product Authentication Metrics</h3>
        <p>The vendor warrants that all units dispatched to customers match descriptions precisely and possess legal clearance validation rules...</p>
      </div>

      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
        <input type="checkbox" id="agree-chk" checked={agreed} onChange={e => setAgreed(e.target.checked)} style={{ marginTop: 3 }} />
        <label htmlFor="agree-chk" style={{ fontSize: 13, color: 'var(--t1)' }}>
          I, <b>{seller.firstName} {seller.lastName}</b>, verify and confirm all operational policies outlined above.
        </label>
      </div>

      <div className="sp-label" style={{ marginBottom: '0.5rem' }}>DIGITAL SIGNATURE BINDING</div>
      <canvas ref={canvasRef} width={400} height={100} className={`sp-sign-area ${signed ? 'signed' : ''}`} style={{ display: 'block', cursor: 'crosshair', touchAction: 'none', background: 'var(--s0)', border: '1px solid var(--border)', borderRadius: 'var(--r-md)' }}
        onMouseDown={startDraw} onMouseMove={draw} onMouseUp={stopDraw} onMouseLeave={stopDraw} />
      
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', marginTop: '0.5rem' }}>
        <p style={{ fontSize: 11, color: 'var(--t3)', flex: 1 }}>Draw your signature using a pointer directly onto the pad interface grid above.</p>
        <button style={{ fontSize: 11, color: 'var(--t3)', background: 'none', border: '1px solid var(--border)', padding: '2px 8px', borderRadius: 4, cursor: 'pointer' }} onClick={() => { canvasRef.current?.getContext('2d')?.clearRect(0, 0, 400, 100); setSigned(false); }}>Clear Signature</button>
      </div>

      <button className="sp-btn-primary" disabled={!agreed || !signed || submitting} onClick={handleCommit}>
        {submitting ? 'Registering Agreement...' : 'Lock and Finalize Merchant Profile'}
      </button>
    </div>
  );
};